module.exports = __webpack_public_path__ + "static/media/review-3.ad4be46a.png";